import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SigninComponent } from './common/signin/signin.component';
import { AuthGuardService } from './services/auth/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'signin',
    pathMatch: 'full',
  },
  {
    path: 'signin',
    component: SigninComponent,
  },
  {
    path: 'agent',
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import('./agent/agent.module').then((m) => m.AgentModule),
  },

  {
    path: 'hubAdmin',
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import('./hubadmin/hubadmin.module').then((m) => m.HubadminModule),
  },
  {
    path: 'redemption',
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import('./redemption/redemption.module').then((m) => m.RedemptionModule),
  },
  {
    path: 'finance',
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import('./finance/finance.module').then((m) => m.FinanceModule),
  },
  {
    path: 'operationalhead',
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import('./operationalhead/operationalhead.module').then(
        (m) => m.OperationalheadModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
